export const COLUMNS = 7;
export const ROWS = 6;
export const WINNING_LENGTH = 4;
